/**
 * Safely parses a JSON string, returning a fallback value if parsing fails.
 * @param jsonString - The JSON string to parse
 * @param fallback - The fallback value to return if parsing fails (default: {})
 * @returns The parsed JSON object or the fallback value
 */
export const safeJSONParse = <T = unknown>(jsonString: string, fallback: T = {} as T): T => {
  try {
    return JSON.parse(jsonString) as T;
  } catch {
    return fallback;
  }
};
